export default __webpack_public_path__ + "images/17f083d7a998890f1c425a50ae298416-home.svg";